var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.multiple
        ? _c(
            "el-form-item",
            { attrs: { prop: _vm.current, label: _vm.labels[_vm.type] } },
            [
              _c("el-input", {
                attrs: { id: _vm.current, placeholder: "请输入" },
                model: {
                  value: _vm.formData[_vm.current],
                  callback: function($$v) {
                    _vm.$set(_vm.formData, _vm.current, $$v)
                  },
                  expression: "formData[current]"
                }
              })
            ],
            1
          )
        : _c("multi-input", {
            attrs: {
              prop: _vm.multipleKey,
              label: _vm.labels[_vm.type],
              rules: _vm.rules[_vm.current],
              count: _vm.count
            },
            model: {
              value: _vm.formData[_vm.multipleKey],
              callback: function($$v) {
                _vm.$set(_vm.formData, _vm.multipleKey, $$v)
              },
              expression: "formData[multipleKey]"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }